import { TFunction } from 'i18next';
import { TimeComponents } from 'parse-ms';

/**
 * @param {TimeComponents} parts
 * @param {TFunction} t
 * @param {keyof TimeComponents | all} precision - minimal unit that should be displayed,
 * default is 'seconds'. If `all` every part is rendered.
 *
 * @returns human readable representation of time parts, also takes plurals into account
 *      eg.: 1 hour 38 minutes and 58 seconds
 */
export const timePartsToHumanReadableString = (
  parts: TimeComponents,
  t: TFunction,
  precision: keyof TimeComponents | 'all' = 'seconds'
): string => {
  let hasPreviousParts = false;
  const empty = '';

  const localizedPart = (key: keyof TimeComponents): string => {
    if (parts[key] === 0 && !hasPreviousParts) {
      return empty;
    }
    hasPreviousParts = true;

    // .slice(0,-1) - is due to i18n
    return `${parts[key]} ${t(`time.${key.slice(0, -1)}`, { count: parts[key] })}`;
  };

  const returnArray: string[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(parts)) {
    const part = localizedPart(key as keyof TimeComponents);
    if (part !== empty) {
      returnArray.push(part);
    }

    if (key === precision) {
      break;
    }
  }

  return returnArray.join(' ').toLocaleLowerCase().trim();
};
